import { useRouter } from "@tanstack/react-router";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

const NotFound = () => {
  const router = useRouter();
  const goBack = () => router.history.back();

  return (
    <>
      <Typography variant="h5" sx={{ pb: 1 }}>
        404 - Page Not Found
      </Typography>
      <Typography>We cannot find the page you requested!</Typography>
      <Box sx={{ pt: 2 }}>
        <Button variant="outlined" onClick={goBack}>
          Go Back
        </Button>
      </Box>
    </>
  );
};

export default NotFound;
